import * as React from "react"
import Box from "@mui/material/Box";

const Academics = () => {
    return (
        <Box sx={{height: '100vh', display: 'flex', justifyContent: 'center', alignItems: 'center'}}>
            <Box
                component="img"
                src="/work-in-progress.png"
                alt="work-in-progress"
                sx={{ height: 150 }}
              />
        </Box>
    )
};

export default Academics;